var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLoop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.419,
    height: 28.415,
    viewBox: "0 0 28.419 28.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_180",
    "data-name": "Trac\\xE9 180",
    d: "M20.856,18.371a11.545,11.545,0,1,0-2.481,2.483h0a2.078,2.078,0,0,0,.174.2L25.385,27.9A1.776,1.776,0,0,0,27.9,25.385L21.06,18.547a1.789,1.789,0,0,0-.2-.178Zm.458-6.827a9.769,9.769,0,1,1-9.769-9.769,9.769,9.769,0,0,1,9.769,9.769Z",
    transform: "translate(0.001 -0.002)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoop);
export default __webpack_public_path__ + "static/media/icon-loop.0b446a5aec61a495afba30f9bf367cff.svg";
export { ForwardRef as ReactComponent };